import React, { FC } from 'react';

const SuitcaseIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.20207 2.24999V1.16666H4.3288V2.24999H6.20207ZM1.51891 3.33333V9.29166H9.01196V3.33333H1.51891ZM9.01196 2.24999C9.53179 2.24999 9.9486 2.73208 9.9486 3.33333V9.29166C9.9486 9.89291 9.53179 10.375 9.01196 10.375H1.51891C0.999077 10.375 0.582275 9.89291 0.582275 9.29166L0.586959 3.33333C0.586959 2.73208 0.999077 2.24999 1.51891 2.24999H3.39217V1.16666C3.39217 0.565412 3.80897 0.0833282 4.3288 0.0833282H6.20207C6.7219 0.0833282 7.1387 0.565412 7.1387 1.16666V2.24999H9.01196Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
};

export default SuitcaseIcon;
